import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
// Rekordlista
import state from './state'
import actions from './rekordlista/actions'
import mutations from './rekordlista/mutations'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  // MOHOSZ Rekordlista
  state,
  actions,
  mutations,
  getters,
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,
})
